export interface Category {
  name: string;
  url: string;
  icon: string;
}

export const categories: Category[] = [
  { name: 'Shoes', url: 'https://kaspreadsheet.com/category-911-Shoes.html', icon: 'ri-footprint-line' },
  { name: 'Hoodies / Sweaters', url: 'https://kaspreadsheet.com/search-912/name/Shoes.html', icon: 'ri-t-shirt-line' },
  { name: 'T-Shirts', url: 'https://kaspreadsheet.com/search-913/name/Shoes.html', icon: 'ri-shirt-line' },
  { name: 'Jackets', url: 'https://kaspreadsheet.com/search-914/name/Shoes.html', icon: 'ri-t-shirt-air-line' },
  { name: 'Pants / Shorts', url: 'https://kaspreadsheet.com/search-915/name/Shoes.html', icon: 'ri-pantone-line' },
  { name: 'Headwear', url: 'https://kaspreadsheet.com/search-916/name/Shoes.html', icon: 'ri-customer-service-2-line' },
  { name: 'Sets', url: 'https://kaspreadsheet.com/search-917/name/Shoes.html', icon: 'ri-stack-line' },
  { name: 'Underwear / Underpants', url: 'https://kaspreadsheet.com/search-918/name/Shoes.html', icon: 'ri-checkbox-blank-line' },
  { name: 'Jersey', url: 'https://kaspreadsheet.com/search-919/name/Shoes.html', icon: 'ri-football-line' },
  { name: 'Accessories', url: 'https://kaspreadsheet.com/search-920/name/Shoes.html', icon: 'ri-glasses-line' },
  { name: 'Bags', url: 'https://kaspreadsheet.com/search-921/name/Shoes.html', icon: 'ri-handbag-line' },
  { name: 'Belts', url: 'https://kaspreadsheet.com/search-922/name/Shoes.html', icon: 'ri-link' },
  { name: 'Perfumes', url: 'https://kaspreadsheet.com/search-923/name/Shoes.html', icon: 'ri-drop-line' },
  { name: 'Other Stuff', url: 'https://kaspreadsheet.com/search-924/name/Shoes.html', icon: 'ri-more-line' },
];